import React from 'react';
import { Link } from 'react-router-dom';
import { Map } from 'immutable';
import autoBind from 'react-autobind';
import Divider from 'material-ui/Divider';
import AddIcon from 'material-ui/svg-icons/content/add-box';
import IconButton from 'material-ui/IconButton';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import { List, ListItem } from 'material-ui/List';
import FieldToggle from '../../components/FieldToggle';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import MapMarker from '../../components/MapMarker';
import { Panel } from '../../components/Panel';
import style from './style.js';

export class MarkerPanel extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  render() {
    const {
      floor,
      toggleMarkerFilter,
      toggleAllMarkerFilter,
      markerFilter,
      match,
      disabled
    } = this.props;
    const { facilityId, buildingId, floorId, markerId } = match.params;
    const markers = this.props.floor.markers();
    // if markerId exists, it is the marker currently being edited
    // and should not be toggleable.
    const allToggled = markerId
      ? markerFilter.size === markers.size - 1
      : markerFilter.size === markers.size;
    return (
      <div>
        <Panel>
          <div className="row middle-xs">
            <div className="col-xs-12 col-sm-6">
              <p className="text-muted">{`${markers.size} markers on ${
                floor.name
              }`}</p>
            </div>
            <div className="col-xs-12 col-sm-6">
              <FlatButton
                icon={<AddIcon />}
                primary
                fullWidth
                label="New Marker"
                containerElement={
                  <Link
                    to={`/facilities/${facilityId}/buildings/${buildingId}/floors/${
                      floor._id
                    }/markers`}
                  />
                }
                disabled={disabled}
              />
            </div>
          </div>
          {markers.size > 0 && (
            <div>
              <List style={style.markerList}>
                {markers.map((marker, index) => {
                  const isEditing = markerId && markerId === marker._id;
                  const isSelected = isEditing
                    ? true
                    : markerFilter.get(marker._id);
                  const markerType = marker.type();
                  return (
                    <div
                      key={marker._id}
                      style={isEditing ? style.currentMarker : {}}
                    >
                      <ListItem
                        primaryText={marker.name}
                        secondaryText={markerType.name}
                        leftIcon={
                          <img
                            src={markerType.image.path}
                            alt={markerType.name}
                          />
                        }
                        rightIconButton={
                          <IconButton
                            className="list_item"
                            tooltip="Edit Marker"
                            tooltipPosition="bottom-right"
                            // Disable currently editing marker
                            disabled={isEditing || disabled}
                            containerElement={
                              <Link
                                className="icon"
                                to={`/facilities/${facilityId}/buildings/${buildingId}/floors/${floorId}/markers/${
                                  marker._id
                                }`}
                              />
                            }
                          >
                            <EditIcon color="#999999" />
                          </IconButton>
                        }
                        rightToggle={
                          <FieldToggle
                            value={isSelected}
                            // Disable currently editing marker
                            disabled={isEditing || disabled}
                            onChange={() => toggleMarkerFilter(marker._id)}
                          />
                        }
                      />
                      <Divider />
                    </div>
                  );
                })}
              </List>
              <div
                className="row end-xs middle-xs"
                style={style.toggleContainer}
              >
                <div className="col-xs-12 col-sm-6">
                  <RaisedButton
                    icon={<AddIcon />}
                    primary
                    fullWidth
                    label="New Marker"
                    containerElement={
                      <Link
                        to={`/facilities/${facilityId}/buildings/${buildingId}/floors/${
                          floor._id
                        }/markers`}
                      />
                    }
                    disabled={disabled}
                  />
                </div>
                <div className="col-xs-12 col-sm-6">
                  <FieldToggle
                    value={allToggled}
                    label="Toggle All"
                    labelPosition="left"
                    onChange={toggleAllMarkerFilter}
                    disabled={disabled}
                  />
                </div>
              </div>
            </div>
          )}
        </Panel>
      </div>
    );
  }
}

export const withMarkerPanel = Component => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      autoBind(this);
      this.state = {
        markerFilter: new Map()
      };
    }

    toggleMarkerFilter(markerId) {
      const { markerFilter } = this.state;
      const newMarkerFilter = markerFilter.get(markerId)
        ? markerFilter.delete(markerId)
        : markerFilter.set(markerId, true);
      this.setState({ markerFilter: newMarkerFilter });
    }

    toggleAllMarkerFilter() {
      const { markerFilter } = this.state;
      this.setState({
        markerFilter: markerFilter.size
          ? new Map()
          : new Map(
              this.props.floor.markers().map(marker => [marker._id, true])
            )
      });
    }

    render() {
      return (
        <Component
          {...this.props}
          markerFilter={this.state.markerFilter}
          toggleMarkerFilter={this.toggleMarkerFilter}
          toggleAllMarkerFilter={this.toggleAllMarkerFilter}
        />
      );
    }
  };
};

export const MarkerPanelMarkers = ({ markerFilter, markers, floor, match }) => {
  // if markerId exists, it is the marker currently being edited
  // and should not be present in these MapMarkers
  const filteredMarkers = match.params.markerId
    ? markers.filter(marker => marker._id !== match.params.markerId)
    : markers;
  return filteredMarkers.map(
    marker =>
      markerFilter.get(marker._id) ? (
        <MapMarker marker={marker} floor={floor} key={marker._id} />
      ) : null
  );
};



// WEBPACK FOOTER //
// ./src/components/MarkerPanel/index.jsx